import { render, staticRenderFns } from "./EditInvoicePage.vue?vue&type=template&id=ec70201e&scoped=true&"
import script from "./EditInvoicePage.vue?vue&type=script&lang=ts&"
export * from "./EditInvoicePage.vue?vue&type=script&lang=ts&"
import style0 from "./EditInvoicePage.vue?vue&type=style&index=0&id=ec70201e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec70201e",
  null
  
)

export default component.exports